
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/campus",
      function () {
        return require("private-next-pages/corporatiu/campus/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/campus"])
      });
    }
  